import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faAlignCenter,
    faArrowsAltH,
    faArrowDown,
    faArrowUp,
    faBold,
    faCamera,
    faExpand,
    faFont,
    faGripLines,
    faGripVertical,
    faItalic,
    faListOl,
    faListUl,
    faPlay,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faTrash,
    faUnderline,
    faXmark
} from '@fortawesome/free-solid-svg-icons'

// Add icons to the library
library.add(
    faAlignCenter,
    faArrowsAltH,
    faArrowDown,
    faArrowUp,
    faBold,
    faCamera,
    faExpand,
    faFont,
    faGripLines,
    faGripVertical,
    faItalic,
    faListOl,
    faListUl,
    faPlay,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faTrash,
    faUnderline,
    faXmark
)

// Register FontAwesome component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)
